package ru.it_mozaika.sender.common.models

import kotlinx.datetime.Instant
import kotlinx.serialization.Contextual
import kotlinx.serialization.Serializable


@Serializable
sealed class SubscriberDataProperty {
    abstract val propertyId: String
    @Contextual
    abstract val values: List<Any>

    @Serializable
    data class StringProperty(override val propertyId: String, override val values: List<String>) : SubscriberDataProperty()

    @Serializable
    data class IntProperty(override val propertyId: String, override val values: List<Int>) : SubscriberDataProperty()

    @Serializable
    data class FloatProperty(override val propertyId: String, override val values: List<Float>) : SubscriberDataProperty()

    @Serializable
    data class DateProperty(override val propertyId: String, @Contextual override val values: List<Instant>) : SubscriberDataProperty()

    @Serializable
    data class BoolProperty(override val propertyId: String, override val values: List<Boolean>) : SubscriberDataProperty()
}

fun SubscriberDataProperty.stringValues() = (this as SubscriberDataProperty.StringProperty).values
fun SubscriberDataProperty.intValues() = (this as SubscriberDataProperty.IntProperty).values
fun SubscriberDataProperty.floatValues() = (this as SubscriberDataProperty.FloatProperty).values
fun SubscriberDataProperty.dateValues() = (this as SubscriberDataProperty.DateProperty).values
fun SubscriberDataProperty.boolValues() = (this as SubscriberDataProperty.BoolProperty).values


@Serializable
data class SubscriberData(
    val id: String,
    val store: String,
    @Contextual val regDate: Instant?,
    val email: String,
    val emailVerified: Boolean = false,
    val phone: String? = null,
    val phoneVerified: Boolean = false,
    var subscriptions: List<String>? = listOf(),
    val emailMessages: List<EmailMessage>? = listOf(),
    val properties: List<SubscriberDataProperty> = listOf()
)

@Serializable
data class Subscription(
    val listId: String,
    val isSubscribed: Boolean
)

@Serializable
data class BasketContent (
    var id: String = "",
    var quantity: Int = 0,
    var price: Float = 0.0f
)

@Serializable
data class SubscriptionListUpdateRequest(
    var name: String,
    var store: String,
    var externalId: String?
)

@Serializable
data class SubscriptionList (
    val id: String,
    var store: String,
    var name: String,
    var externalId: String?
)

@Serializable
data class SubscriptionListDaysStats(
    val day: String,
    val subscribe: Int,
    val unsubscribe: Int
)

@Serializable
data class SubscribeEmailRequest(
    val email: String = "",
    val store: String? = null,
    val confirmed: Boolean = false,
    val subscriptionLists: List<String> = listOf(),
    val name: String? = null,
    val phone: String? = null,
    val description: String? = null
)

@Serializable
data class UnsubscribeEmailRequest(
    val email: String = "",
    val store: String? = null,
    val subscriptionLists: List<String> = listOf()
)

@Serializable
sealed class SubscriberDataFieldValue {
    abstract val id: String
    @Serializable
    data class StringFieldValue(
        override val id: String,
        val value: String
    ) : SubscriberDataFieldValue()
}
@Serializable
data class SubscribersEmailFilterResponse(
    val ids: List<String>,
    val errors: List<String>
)
@Serializable
data class SubscribersListFilter(
    val subscriptionFilter: Map<String, Boolean>,
    val idsFilter: List<String>,
    val columnsFilter: List<ColumnsFilter>,
    val subscribersPropertiesFilter: List<SubscribersPropertyFilter>
)


